




























import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Toast } from "vant";

const retreatCouponModule = namespace("retreatCoupon");

@Component({
  components: {}
})
export default class Search extends Vue {
  @retreatCouponModule.State("selectStep") active!: number;
  value: any = "";

  mounted() {
    (this as any).$wechartfunc();
    this.setActive();
  }

  setActive() {
    this.$store.commit("retreatCoupon/setSelectStep", 1);
  }

  async handleSearchClick() {
    if (this.value == "") {
      Toast("请输入券码");
      return false;
    }
    const { error, success } = await this.$store.dispatch(
      "retreatCoupon/getCoponByCode",
      {
        couponInstanceQrCode: this.value
      }
    );
    if (success) {
      this.$router.push({
        path: `/retreatCoupon/sureRetreat`,
        query: {
          couponInstanceQrCode: this.value
        }
      });
    } else {
      Toast(error.msg);
    }
  }
  async handleScanCodeClick() {
    const scanQRCode: any = await (this as any).$wechartfunc("scanQRCode");
    if (scanQRCode) {
      const { error, success } = await this.$store.dispatch(
        "retreatCoupon/getCoponByCode",
        {
          couponInstanceQrCode: scanQRCode
        }
      );
      if (success) {
        this.$router.push({
          path: `/retreatCoupon/sureRetreat`,
          query: {
            couponInstanceQrCode: scanQRCode
          }
        });
      } else {
        Toast(error.msg);
      }
    } else {
      Toast("会员码不存在");
    }
  }
}
